// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".echo-ios-user_protocol[data-v-285cc426]{width:100%;height:100vh;overflow-y:hidden;background-color:#fff;display:flex;flex-direction:column}.echo-ios-user_protocol .page-container[data-v-285cc426]{box-sizing:border-box;background-color:#fff;padding:0 15px;flex:1}.echo-ios-user_protocol .page-container .iframe[data-v-285cc426]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
